import { render, staticRenderFns } from "./PlaceOrderList.vue?vue&type=template&id=278b90af&scoped=true&"
import script from "./PlaceOrderList.vue?vue&type=script&lang=js&"
export * from "./PlaceOrderList.vue?vue&type=script&lang=js&"
import style0 from "./PlaceOrderList.vue?vue&type=style&index=0&id=278b90af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278b90af",
  null
  
)

export default component.exports